import { render, staticRenderFns } from "./IconStar.vue?vue&type=template&id=a723e70e&"
import script from "./IconStar.vue?vue&type=script&lang=ts&"
export * from "./IconStar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports